/**

 * Search/cart panels: shared fixed anchor, only one open at a time.

 * Mobile: portaled to body + tap toggle. Desktop: hover/click with mutual exclusion.

 */

(function () {

  const MOBILE_MQ = window.matchMedia('(max-width: 989px)');

  const UTILITY_SELECTOR =
    '.editorial-homepage__utility--search, .editorial-homepage__utility--cart, .editorial-homepage__utility--language';

  const POPOVER_SELECTOR =
    '.editorial-homepage__popover--search, .editorial-homepage__popover--cart, .editorial-homepage__popover--language, .editorial-homepage__popover--portaled';

  const OPEN_CLASS = 'is-mobile-popover-open';

  const PORTAL_CLASS = 'editorial-homepage__popover--portaled';

  const OPEN_POPOVER_CLASS = 'is-open';

  const MENU_HIDDEN_CLASS = 'is-mobile-menu-hidden-for-panel';

  const PANEL_ACTIVE_CLASS = 'is-mobile-panel-active';

  const CART_PANEL_INTERACTION_SELECTOR =
    '[data-editorial-cart-panel], [data-cart-variant-dropdown], [data-cart-dropdown-menu], [data-cart-dropdown-option], [data-cart-dropdown-trigger], [data-cart-variant-edit], [data-cart-qty], [data-cart-remove]';



  /** @type {Map<HTMLElement, { popover: HTMLElement, placeholder: Comment, portaled: boolean }>} */

  const registry = new Map();



  /**

   * @param {HTMLElement} utility

   * @returns {HTMLElement | null}

   */

  function getHomepageRoot(utility) {

    return utility.closest('.editorial-homepage');

  }



  /**

   * @param {HTMLElement | null} root

   */

  function setPanelMenuHidden(root, hidden) {

    if (!root) {

      return;

    }



    root.classList.toggle(MENU_HIDDEN_CLASS, hidden);

    root.classList.toggle(PANEL_ACTIVE_CLASS, hidden);

  }



  /**

   * @returns {boolean}

   */

  function anyUtilityOpen() {

    let open = false;



    registry.forEach(function (_, utility) {

      if (utility.classList.contains(OPEN_CLASS)) {

        open = true;

      }

    });



    return open;

  }



  /**

   * @param {HTMLElement | null} root

   */

  function syncPanelMenuVisibility(root) {

    if (!root) {

      return;

    }



    setPanelMenuHidden(root, anyUtilityOpen());

  }



  /**

   * @param {HTMLElement} utility

   */

  function getPopover(utility) {

    const entry = registry.get(utility);

    if (entry) {

      return entry.popover;

    }



    return utility.querySelector('.editorial-homepage__popover');

  }



  /**

   * @param {HTMLElement} utility

   */

  function portalPopover(utility) {

    const entry = registry.get(utility);

    if (!entry || entry.portaled) {

      return;

    }



    const { popover, placeholder } = entry;

    utility.insertBefore(placeholder, popover);

    document.body.appendChild(popover);

    popover.classList.add(PORTAL_CLASS);

    if (utility.dataset.editorialUtilityId) {
      popover.dataset.editorialUtilityId = utility.dataset.editorialUtilityId;
    }

    entry.portaled = true;

  }



  /**

   * @param {HTMLElement} utility

   */

  function restorePopover(utility) {

    const entry = registry.get(utility);

    if (!entry || !entry.portaled) {

      return;

    }



    const { popover, placeholder } = entry;

    utility.classList.remove(OPEN_CLASS);

    popover.classList.remove(OPEN_POPOVER_CLASS);



    const trigger = utility.querySelector('.editorial-homepage__action');

    if (trigger) {

      trigger.setAttribute('aria-expanded', 'false');

    }



    if (placeholder.parentNode) {

      placeholder.parentNode.insertBefore(popover, placeholder.nextSibling);

    }



    placeholder.remove();

    popover.classList.remove(PORTAL_CLASS);

    entry.portaled = false;

  }



  /**

   * @param {HTMLElement} utility

   */

  function blurUtilityTrigger(utility) {

    const trigger = utility.querySelector('.editorial-homepage__action');

    if (trigger instanceof HTMLElement) {

      trigger.blur();

    }

  }



  function closeAllUtilities() {

    /** @type {HTMLElement | null} */

    let root = null;



    registry.forEach(function (_, utility) {

      if (!root) {

        root = getHomepageRoot(utility);

      }



      const popover = getPopover(utility);

      utility.classList.remove(OPEN_CLASS);



      if (popover) {

        popover.classList.remove(OPEN_POPOVER_CLASS);

      }



      const trigger = utility.querySelector('.editorial-homepage__action');

      if (trigger) {

        trigger.setAttribute('aria-expanded', 'false');

      }



      blurUtilityTrigger(utility);

    });



    syncPanelMenuVisibility(root);

  }



  /**

   * @param {HTMLElement | null} exceptUtility

   */

  function closeAllExcept(exceptUtility) {

    registry.forEach(function (_, utility) {

      if (utility === exceptUtility) {

        return;

      }



      utility.classList.remove(OPEN_CLASS);

      const popover = getPopover(utility);



      if (popover) {

        popover.classList.remove(OPEN_POPOVER_CLASS);

      }



      const trigger = utility.querySelector('.editorial-homepage__action');

      if (trigger) {

        trigger.setAttribute('aria-expanded', 'false');

      }



      blurUtilityTrigger(utility);

    });

  }



  /**

   * @param {HTMLElement} utility

   * @param {boolean} open

   */

  function setUtilityOpen(utility, open) {

    const popover = getPopover(utility);

    const trigger = utility.querySelector('.editorial-homepage__action');



    if (!popover || !trigger) {

      return;

    }



    if (MOBILE_MQ.matches) {

      portalPopover(utility);

    }



    if (open) {

      closeAllExcept(utility);

    }



    utility.classList.toggle(OPEN_CLASS, open);

    popover.classList.toggle(OPEN_POPOVER_CLASS, open);

    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      if (utility.classList.contains('editorial-homepage__utility--language')) {
        document.dispatchEvent(new CustomEvent('judy:language-sync'));
      }

      document.dispatchEvent(
        new CustomEvent('editorial:popover-position', {
          detail: { utility: utility },
        })
      );
      if (window.EditorialPopoverPosition && typeof window.EditorialPopoverPosition.schedule === 'function') {
        window.EditorialPopoverPosition.schedule(utility);
      }
    }



    const root = getHomepageRoot(utility);



    if (MOBILE_MQ.matches && open && root && !root.classList.contains('is-mobile-nav-open')) {

      root.classList.add('is-mobile-nav-open');



      const panel = root.querySelector('[data-mobile-nav-panel]');

      const toggle = root.querySelector('[data-mobile-nav-toggle]');



      if (panel) {

        panel.removeAttribute('hidden');

        panel.setAttribute('aria-hidden', 'false');

      }



      if (toggle) {

        toggle.setAttribute('aria-expanded', 'true');

      }

    }



    syncPanelMenuVisibility(root);

  }



  /**

   * @param {HTMLElement} utility

   * @param {MouseEvent} event

   */

  /**
   * @param {Node | null} node
   * @returns {boolean}
   */
  function isCartVariantDropdownPointer(node) {
    if (!(node instanceof Element)) {
      return false;
    }

    return Boolean(node.closest('[data-cart-dropdown-menu], [data-cart-variant-dropdown]'));
  }

  function handleDesktopPointerLeave(utility, event) {

    if (MOBILE_MQ.matches) {

      return;

    }



    const popover = getPopover(utility);

    const related = event.relatedTarget;



    if (related instanceof Node) {

      if (utility.contains(related) || (popover && popover.contains(related))) {

        return;

      }

      if (utility.classList.contains('editorial-homepage__utility--cart') && isCartVariantDropdownPointer(related)) {

        return;

      }

    }



    setUtilityOpen(utility, false);

  }



  /**

   * @param {HTMLElement} utility

   */

  function initUtility(utility) {

    if (!(utility instanceof HTMLElement) || utility.dataset.mobilePopoverInit === 'true') {

      return;

    }



    const popover = utility.querySelector('.editorial-homepage__popover');

    const trigger = utility.querySelector('.editorial-homepage__action');



    if (!popover || !trigger) {

      return;

    }



    utility.dataset.mobilePopoverInit = 'true';

    registry.set(utility, {

      popover: popover,

      placeholder: document.createComment('editorial-popover-anchor'),

      portaled: false,

    });



    trigger.addEventListener('mousedown', function (event) {

      if (!MOBILE_MQ.matches) {

        event.preventDefault();

      }

    });



    trigger.addEventListener('click', function (event) {

      event.preventDefault();

      event.stopPropagation();



      const willOpen = !utility.classList.contains(OPEN_CLASS);

      setUtilityOpen(utility, willOpen);

    });



    utility.addEventListener('mouseenter', function () {

      if (MOBILE_MQ.matches) {

        return;

      }



      setUtilityOpen(utility, true);

    });



    utility.addEventListener('mouseleave', function (event) {

      handleDesktopPointerLeave(utility, event);

    });



    popover.addEventListener('mouseenter', function () {

      if (MOBILE_MQ.matches) {

        return;

      }



      setUtilityOpen(utility, true);

    });



    popover.addEventListener('mouseleave', function (event) {

      handleDesktopPointerLeave(utility, event);

    });

  }



  function syncPortalMode() {

    if (MOBILE_MQ.matches) {

      registry.forEach(function (_, utility) {

        portalPopover(utility);

      });

      return;

    }



    closeAllUtilities();

    registry.forEach(function (_, utility) {

      restorePopover(utility);

    });

  }



  function initAll() {

    document.querySelectorAll(UTILITY_SELECTOR).forEach(initUtility);

    syncPortalMode();

  }



  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const closeButton = event.target.closest('[data-editorial-panel-close]');
      if (closeButton instanceof HTMLButtonElement) {
        event.preventDefault();
        event.stopPropagation();
        const popover = closeButton.closest(POPOVER_SELECTOR);
        if (popover) {
          registry.forEach(function (_, utility) {
            if (getPopover(utility) === popover) {
              setUtilityOpen(utility, false);
            }
          });
        } else {
          closeAllUtilities();
        }
        return;
      }

      if (event.target.closest(UTILITY_SELECTOR)) {
        return;
      }

      if (event.target.closest(POPOVER_SELECTOR)) {
        return;
      }

      if (event.target.closest(CART_PANEL_INTERACTION_SELECTOR)) {
        return;
      }

      closeAllUtilities();
    },
    true
  );



  document.addEventListener('editorial:mobile-nav-close', function () {

    registry.forEach(function (_, utility) {

      const root = getHomepageRoot(utility);

      if (root) {

        setPanelMenuHidden(root, false);

      }

    });



    closeAllUtilities();

  });



  if (typeof MOBILE_MQ.addEventListener === 'function') {

    MOBILE_MQ.addEventListener('change', syncPortalMode);

  } else if (typeof MOBILE_MQ.addListener === 'function') {

    MOBILE_MQ.addListener(syncPortalMode);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAll);

  } else {

    initAll();

  }



  document.addEventListener('shopify:section:load', initAll);

})();

